import * as React from 'react';

import { DropdownPicker, DropdownPickerProps } from 'components/pickers/dropdown-picker';
import { OptionGroup, OptionGroupProps } from 'components/base/option-group';
import { Container } from 'theme/layout';

const CONTAINER_MARGIN_BOTTOM = 15;

/**
 * A value picker that allows a user to select an option from a dropdown.
 *
 * @param props - Render props
 */
export function DropdownSelector<T>(props: DropdownSelectorProps<T>) {
  const {
    accentColor,
    title,
    description,
    icon,
    maximumAllowed,
    selectedValue,
    onChange,
    options,
    disabled,
    marginHorizontal,
  } = props;

  return (
    <OptionGroup accentColor={accentColor} title={title} description={description} icon={icon}>
      <Container marginBottom={CONTAINER_MARGIN_BOTTOM}>
        <DropdownPicker
          maximumAllowed={maximumAllowed}
          selectedValue={selectedValue}
          onChange={onChange}
          options={options}
          disabled={disabled}
          marginHorizontal={marginHorizontal}
        />
      </Container>
    </OptionGroup>
  );
}
/* Type definitions */
export type DropdownSelectorProps<T> = DropdownPickerProps<T> & OptionGroupProps;
